import { render, staticRenderFns } from "./SacResponseAnswer.vue?vue&type=template&id=0bfb5ebf&scoped=true"
import script from "./SacResponseAnswer.vue?vue&type=script&lang=js"
export * from "./SacResponseAnswer.vue?vue&type=script&lang=js"
import style0 from "./SacResponseAnswer.vue?vue&type=style&index=0&id=0bfb5ebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb5ebf",
  null
  
)

export default component.exports